import { FetchingKeys, Item } from "./types";
import { UPDATE_FETCHING_KEYS, UPDATE_QUEUE_LIST, UpdateFetchingKeysAction, UpdateQueueListAction } from "./reducer";

export function updateQueueList(userId: number, queueName: string, list: Item[]): UpdateQueueListAction {
  return {
    payload: { list, queueName, userId },
    type: UPDATE_QUEUE_LIST,
  };
}

export function updateFetchingKeys(queueName: string, fetchingKeys: FetchingKeys): UpdateFetchingKeysAction {
  return {
    payload: { fetchingKeys, queueName },
    type: UPDATE_FETCHING_KEYS,
  };
}
